export default __webpack_public_path__ + "images/EMT.f9ff30a.png";